import { Zap, Layers, Check } from 'lucide-react';

const MODES = [
  { id: 'simple', label: 'Simple', Icon: Zap, color: '#10B981', blurb: 'A prompt plus optional opening/closing images per scene. No characters or locations to manage.',
    bullets: ['Prompt → video (frames optional)', 'Upload, generate or pick frame images', 'Optional music / voice-over track', 'Style, format, resolution and model still yours'] },
  { id: 'advanced', label: 'Advanced', Icon: Layers, color: '#FF4500', blurb: 'Full production pipeline with cast, locations, dialogue, voices and identity-locked characters.',
    bullets: ['Characters & locations with reference art', 'Dialogue, TTS and native voices', 'Script analysis & cast review', 'Translations, lip-sync and more'] },
];

// Simple vs Advanced scene creation — shared by the New Project wizard and the project settings dialog.
export const CreationModeSelector = ({ value = 'advanced', onChange, testIdPrefix = 'mode' }) => (
  <div data-testid={`${testIdPrefix}-selector`} className="grid grid-cols-1 sm:grid-cols-2 gap-3">
    {MODES.map(m => {
      const active = value === m.id;
      return (
        <button key={m.id} type="button" data-testid={`${testIdPrefix}-${m.id}`} onClick={() => onChange(m.id)} aria-pressed={active}
          className="text-left rounded-xl border p-4 transition-[border-color,box-shadow,transform] duration-200 hover:-translate-y-0.5"
          style={{ borderColor: active ? m.color : 'rgba(255,255,255,0.08)', boxShadow: active ? `0 0 0 1px ${m.color}66, 0 10px 28px -12px ${m.color}66` : 'none', background: active ? `${m.color}0d` : 'rgba(255,255,255,0.02)' }}>
          <div className="flex items-center justify-between mb-1.5">
            <span className="flex items-center gap-2 text-sm font-semibold text-white"><m.Icon className="w-4 h-4" style={{ color: m.color }} /> {m.label}</span>
            {active && <Check className="w-4 h-4" style={{ color: m.color }} />}
          </div>
          <p className="text-[11px] text-[#8A8A93] leading-snug mb-2">{m.blurb}</p>
          <ul className="space-y-0.5">
            {m.bullets.map(b => <li key={b} className="text-[10px] text-[#C9C9CF] flex items-start gap-1.5"><span className="mt-[5px] w-1 h-1 rounded-full shrink-0" style={{ background: m.color }} /> {b}</li>)}
          </ul>
        </button>
      );
    })}
  </div>
);
